module.exports = __webpack_public_path__ + "img/sv25.5fe89b9e.svg";